<nb-card [class.filter]="value?.length > 0">
  <nb-card-body>
    <div class="input-group ">
      <input type="text" class="form-control" placeholder="Search for..." [(ngModel)]="value" (ngModelChange)="update($event)">
      <div *ngIf="dropdownOptions" class="search-dropdown">
        <ngx-form-dropdown [title]="undefined" [options]="dropdownOptions" [(value)]="selectedOption" (valueChange)="onColumn($event)"></ngx-form-dropdown>
      </div>
<!--      <span class="input-group-append">
        <button class="btn btn-default input-group-text">
          <i class="nb-search"></i>
        </button>
      </span>-->
    </div>
  </nb-card-body>
</nb-card>
